import '../../../../styles/oa.scss';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { ListView,PullToRefresh,Button} from 'antd-mobile';
import SearchWrapper from '@/components/searchWrapper';
import Filter from '@/components/filter';
import { MyContext } from '@/utils/contextManager';
import { leaveList } from '../../../../services/saas/oa';
import { useHistory } from 'react-router';
import sysConfig from '@/sysConfig';
import { getUser } from '../../../../utils';
const { preRouteUrl } = sysConfig;

function ListWrap(props) {
  return  <div className="oatb-list">
            <div className="oatb-list-label">
              <span className="oatb-list-label-span">用户名</span>
              <span className="oatb-list-label-span">请假类型</span>
              <span className="oatb-list-label-span">申请时间</span>
              <span className="oatb-list-label-span">状态</span>
            </div>
            <div className="oatb-list-box">
                {props.children}
            </div>
          </div>
}


function LeaveList(props) {
  const pageSize = 20;
  let [pageIndex, setIndex] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [draging, setDraging] = useState(false);
  const [keyValue, setKeyValue] = useState('');
  const [filter, setFilter] = useState({});

  const { setFilters } = useContext(MyContext);
  const history = useHistory();

  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSouce] = useState(dataS);

  const getData = async function (page) {
    setLoading(true);
    const { startTime} = filter;
    const { deptId } = getUser() || {};
    const param = {
      current: page,
      size: pageSize,
      applyTime:startTime,
      orgId:deptId,
      userName: keyValue,
      leaveFormStatus:1
    };

    const respActive = await leaveList(param);
    if (respActive&&respActive.success && respActive.data) {
      let leaveList = [];
      if (page !== 1) {
        leaveList = [...data];
      }
      leaveList = [
        ...leaveList,
        ...respActive.data.records.map(item => ({
          userName: item.userName,
          deptName: item.deptName,
          typeName: item.typeName,
          leaveFormStatus:item.leaveFormStatus,
          leaveFormStatusName:item.leaveFormStatusName,
          startTime: item.startTime,
          endTime: item.endTime,
          leaveId: item.id,
          applyTime: item.applyTime
        }))
      ];

      setLoading(false);
      setDraging(false);
      setData(leaveList);
      setDataSouce(dataSource.cloneWithRows(leaveList));
      setHasMore(respActive.data.current < respActive.data.pages);
      setIndex(page);
    }
  };

  const onEndReached = function () {
    if (!loading && hasMore) {
      getData(++pageIndex);
    }
  };

  useEffect(() => {
    getData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, keyValue]);

  useEffect(() => {
    setFilters(
      <Filter
        data={[]}
        enableTime='single'
        handleSearch={(item) => {
          setFilter(item);
        }}
      ></Filter>,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listRef = useRef();
  const row = (rowData, sectionID, rowID) => {
    const { leaveId,userName,typeName,applyTime} = rowData;
    return (
      <div className="list-box"
        key={rowID}
        onClick ={() =>
            history.push(`${preRouteUrl}/oa/leave/auditDetail/${leaveId}`)
        }
      >
        <span className="oatb-list-item-span line-limit-length item">{userName}</span>
        <span className="oatb-list-item-span line-limit-length item">{typeName}</span>
        <span className="oatb-list-item-span line-limit-length item">{(applyTime||'').split(" ")[0]}</span>
        <span className="item" style={{margin:5}}><Button type="primary" inline size="small">审核</Button></span>

      </div>
    );
  };
  return (
    <ListView
      ref={listRef}
      dataSource={dataSource}
      initialListSize={pageSize}
      renderHeader={() => <SearchWrapper onChange={setKeyValue} />}
      renderFooter={() => (
        <div style={{ padding: 30, textAlign: 'center' }}>
          {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
        </div>
      )}
      renderBodyComponent={() => <ListWrap />}
      renderRow={row}
      className="active-list-wrap"
      pageSize={pageSize}
      onScroll={() => {
        console.log('scroll');
      }}
      scrollRenderAheadDistance={500}
      onEndReached={onEndReached}
      onEndReachedThreshold={10}
      pullToRefresh={
        <PullToRefresh
          refreshing={draging}
          onRefresh={() => {
            setDraging();
            getData(1);
          }
        }
      />
      }
    />
  );
}

export default LeaveList;

